export const COLOR_ALL_JOBS = '#7B61FF'
export const COLOR_CX_WON = '#0E9F9F'
export const COLOR_OP_WON = '#E5399B'

export const COLOR_FIRST_BID_ANALYSIS = '#3B82F6'
export const COLOR_ALLOCATION = '#F5A524'
export const COLOR_FIRST_BID_TO_ALLOCATION = '#30A46C'
export const COLOR_LOWEST_BID = '#7B61FF'

export const BID_ANALYSIS_CHART_HEIGHT = 320

export const BID_ANALYSIS_EARLIEST_DATE = new Date(2024, 6, 1)

export const BID_ANALYSIS_INFO = [
  'Shows how competitively the network responds to posted jobs, including the number of ' +
    'offers each job receives and how quickly the first bid, lowest bid, and allocation ' +
    'occur after posting. Offers from both networks are included — Driver App bids and ' +
    'Courier Exchange quotes.',
  'Each job is assigned to the date it was posted to the network. Cancelled and quote-lost ' +
    'jobs are excluded. Figures are refreshed twice daily, so recent activity may take up ' +
    'to approximately 12 hours to appear.',
].join('\n\n')

export const BID_ANALYSIS_FOOTNOTES = [
  'Each job is assigned to the date it was posted to the network and counted ' +
    'once per chart. Cancelled and quote-lost jobs are excluded. Offers from ' +
    'both networks are included: Driver App bids and Courier Exchange quotes.',
  'Figures are refreshed twice daily, so recent activity may take up to ' +
    'approximately 12 hours to appear.',
]
